import { Col, Form, FormGroup, Input, Label } from "reactstrap";
import { PostTitle, PostTitlePlaceholder, PostCategory, PostContent, PostTypePlaceholder, BlogPostText } from "../../../Constant";
import RadioTypeForm from "./RadioTypeForm";
import { Typeahead } from "react-bootstrap-typeahead";
import { POST_TYPE_DATA } from "../../../Data/Blog";
import SimpleMDE from "react-simplemde-editor";

export const FormPost = () => {
  return (
    <Form className="row needs-validation">
      <Col sm="12">
        <FormGroup>
          <Label check>{PostTitle}:</Label>
          <Input type="text" placeholder={PostTitlePlaceholder} />
        </FormGroup>
        <RadioTypeForm />
        <FormGroup>
          <div className="col-form-Label">
            {PostCategory}:
            <Typeahead id="multiple-typeahead" className="mt-2" defaultSelected={POST_TYPE_DATA} labelKey="name" multiple options={POST_TYPE_DATA} placeholder={PostTypePlaceholder} />
          </div>
        </FormGroup>
        <div className="email-wrapper">
          <div className="theme-form">
            <FormGroup>
              <Label check>{PostContent}:</Label>
              <SimpleMDE id="editor_container" value={BlogPostText} options={{ autofocus: true, spellChecker: false }} />
            </FormGroup>
          </div>
        </div>
      </Col>
    </Form>
  );
};
